const { items: wixData } = require('@wix/data');

const { COLLECTIONS } = require('../public/consts');
const { queryAllItems } = require('../public/data');

const { TASKS } = require('./productTasks/consts');
const { TASK_TYPE } = require('./tasks/consts');
const { taskManager } = require('./tasks/taskManager');

async function updateMissingSkusForExistingProducts() {
  const baseQuery = wixData.query(COLLECTIONS.CMS_PRODUCTS);
  const query = baseQuery.isEmpty('sku').or(baseQuery.eq('sku', ''));
  const products = await queryAllItems(query);

  console.log(`Found ${products.length} products with missing sku`);
  if (products.length > 0) {
    for (const product of products) {
      taskManager().schedule({
        name: TASKS.CMS_PRODUCT_UPDATE_SKU.name,
        data: { storeProductId: product.storeProduct, productId: product._id },
        type: TASK_TYPE.SCHEDULED,
        parentTaskId: undefined,
      });
    }
  }
}

module.exports = { updateMissingSkusForExistingProducts };
